import { getTheme } from "./registry";
import type { ThemeBackdropSlot } from "./types";

import { useTheme } from "@/components/theme-provider-context";

/** Renders the active theme's decorative layer for this slot; nothing for light and dark. */
export function ThemeBackdrop({ slot }: { slot: ThemeBackdropSlot }) {
  const { theme } = useTheme();
  const Backdrop = getTheme(theme).backdrops?.[slot];

  return Backdrop ? <Backdrop /> : null;
}
